
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cuenta/recuperacion",
      function () {
        return require("private-next-pages/cuenta/recuperacion/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cuenta/recuperacion"])
      });
    }
  